import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import { routeModules } from "../../../src/config/routeconfig";
import Layout from "../../layout/Layout";
import Loading from "../../common/Laoding";
import Viewallrefunds from "./Viewallrefunds";

const navItems = routeModules?.refunds?.sidebar;

const Refundsmodule = () => {
  const [activeItem, setActiveItem] = useState(navItems[0]?.label || "");
  const [isLoading, setIsLoading] = useState(true);

  const renderContent = () => {
    switch (activeItem) {
      case "View all Refunds":
        return <Viewallrefunds />;
      default:
        return "Test Page";
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Stop loading after 2 seconds
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Layout
        module={"refunds"}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
          // p: 3,
        }}
      >
        <Toolbar />
        <Container
          maxWidth={false}
          sx={{
            height: "100vh",
            overflowY: "scroll",
            scrollbarWidth: "none", // Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Chrome, Safari
            },
          }}
        >
          {renderContent()}
        </Container>
      </Box>
    </Box>
  );
};

export default Refundsmodule;
